import { request } from './client';

export const apiCreateReturn = (payload) =>
  request('/returns', { method: 'POST', body: payload });

export const apiGetMyReturns = () => request('/returns/mine');

export const apiGetReturnReasons = () => request('/returns/reasons');
